import React, {Component} from 'react';
import {ConnectDropTarget, DropTarget, DropTargetSpec} from 'react-dnd';
import styled, {css} from 'styled-components';

import {VisualRecipientModel} from '../../../../models/api/visualRecipientModel';
import {RecipientsDragItem, RecipientsDragType, RecipientsDropResult} from './recipientsDragSource';

/*
 * Types.
 */

export interface RecipientsDropTargetProps {
  onDrop: RecipientsDropHandler;
}

export type RecipientsDropHandler = (recipients: ReadonlyArray<VisualRecipientModel>) => RecipientsDropResult;

interface RecipientsDropTargetCollectedProps {
  connectDropTarget: ConnectDropTarget;
  areRecipientsHovering: boolean;
}

interface RecipientsDropTargetComponentProps
  extends RecipientsDropTargetProps,
    RecipientsDropTargetCollectedProps {}

/*
 * DnD.
 */

const spec: DropTargetSpec<RecipientsDropTargetProps, RecipientsDragItem, RecipientsDropResult> = {
  drop(props, monitor) {
    const item = monitor.getItem();
    return props.onDrop(item.recipients);
  },
};

/*
 * Style.
 */

interface DropTargetStyleProps {
  $areRecipientsHovering?: boolean;
}
const StyledDropTargetDiv = styled.div<DropTargetStyleProps>`
  border-radius: 6px;

  ${(p) => maybeAddRecipientsHoverStyle(p)};
`;

function maybeAddRecipientsHoverStyle(props: DropTargetStyleProps) {
  if (!props.$areRecipientsHovering) {
    return undefined;
  }

  return css`
    background-color: ${(p) => p.theme.palette.grey.shade20};
  `;
}

/*
 * Component.
 */

class RecipientsDropTargetComponent extends Component<RecipientsDropTargetComponentProps> {
  render() {
    const {connectDropTarget, children} = this.props;
    return connectDropTarget(
      <div>
        <StyledDropTargetDiv $areRecipientsHovering={this.props.areRecipientsHovering}>
          {children}
        </StyledDropTargetDiv>
      </div>,
    );
  }
}

export const RecipientsDropTarget = DropTarget(RecipientsDragType, spec, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  areRecipientsHovering: monitor.isOver() && monitor.canDrop(),
}))(RecipientsDropTargetComponent);
